// extracted by mini-css-extract-plugin
export default {"textTbCell":"textTbCell_textTbCell__8Telh"};